/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { useHistory } from 'react-router-dom'
import { postRequestOptions } from '../helpers/Fetchwrapper';
import Swal from 'sweetalert2';
import Spinner from 'react-bootstrap/Spinner';

function Login() {
	let history = useHistory();
	const [email, setEmail] = useState('');
	const [password, setPassword] = useState('');
	const [loading, setLoading] = useState(false);
	const jwt = JSON.parse(localStorage.getItem("MyToken")) ? JSON.parse(localStorage.getItem("MyToken")) : null;
	const queryString = window.location.search;
	const urlParams = new URLSearchParams(queryString);
	const authorizationCode = urlParams.get('code');



	useEffect(() => {
		if (jwt === null)
			return;
		history.push('/');

	}, []);

	const handleEmailChange = (e) => {
		setEmail(e.target.value);
	}

	const handlePasswordChange = (e) => {
		setPassword(e.target.value);
	}

	

	const handleSubmit = (evt) => {
		evt.preventDefault();
		setLoading(true);
		
		const formData = {
			email: email,
			password: password
		};
		const requestOptions = postRequestOptions(formData)

		fetch(process.env.REACT_APP_API_URL + "auth/login", requestOptions)
			.then((resp) => {
				return resp.json()
			})
			.then((resp) => {
				if (resp.token) {
					// Success - token received
					localStorage.setItem("MyToken", JSON.stringify(resp.token));
					window.location.reload();
				}
				else {
					// Handle validation errors
					if (resp.errors && typeof resp.errors === 'object') {
						let errorMsg = '';
						Object.keys(resp.errors).forEach(field => {
							errorMsg += `• ${field}: ${resp.errors[field].join(', ')}<br>`;
						});
						Swal.fire({
							icon: 'error',
							title: 'Validation Errors',
							html: errorMsg,
							confirmButtonColor: '#d33'
						});
					} else {
						// Handle other error messages
						const errorsMessage = resp.message || resp.errorMessage || resp.error || 'Login failed';
						Swal.fire({
							icon: 'error',
							title: 'Login Failed',
							html: errorsMessage,
							confirmButtonColor: '#d33'
						});
					}
				}
			})
			.catch((error) => {
				console.error('Login error:', error);
				Swal.fire({
					icon: 'error',
					title: 'Connection Error',
					text: 'Unable to connect to server. Please try again.',
					confirmButtonColor: '#d33'
				});
			})
			.finally(() => {
				setLoading(false);
			});
	}

	return (
		<>
			{(jwt === null && loading === false) &&

				// <div className="login login-4 login-signin-on d-flex flex-row-fluid" id="kt_login">
				//     <div className="d-flex flex-center flex-row-fluid bgi-size-cover bgi-position-top bgi-no-repeat" style={{ 'backgroundColor': '#fff' }}>
				//         <div className="login-form text-center p-7 position-relative overflow-hidden">

				//             <div className="d-flex flex-center mb-15">
				//                 <a href="/">
				//                     <img src="/media/logos/logo.png" className="max-h-75px" alt="" />
				//                 </a>
				//             </div>

				//             <div className="login-signin">
				//                 <div className="mb-20">
				//                     <h3>Sign In To Brac Maintenance</h3>
				//                     <div className="text-muted font-weight-bold">Enter your details to login to your account:</div>
				//                 </div>
				//                 <form onSubmit={handleSubmit} className="form" id="kt_login_signin_form">
				//                     <div className="form-group mb-5">
				//                         <input className="form-control h-auto form-control-solid py-4 px-8" type="text" placeholder="Email" name="email" value={email} onChange={handleEmailChange} autoComplete="off" />
				//                     </div>
				//                     <div className="form-group mb-5">
				//                         <input className="form-control h-auto form-control-solid py-4 px-8" type="password" placeholder="Password" name="password" value={password} onChange={handlePasswordChange} />
				//                     </div>

				//                     <button id="kt_login_signin_submit" className="btn border-active btn-primary font-weight-bold px-9 py-4 my-3 mx-1">Sign In</button>
				//                     <a href={process.env.REACT_APP_BRAC_SIS_URL + "auth?client_id=brac_mas&&response_type=code"} id="kt_login_signin_submit" className="btn px-9 py-4 my-3 mx-1 btn-outline btn-outline-dashed btn-outline-danger btn-active-light-danger">Use BRAC SIS</a>
				//                 </form>

				//             </div>


				//         </div>
				//     </div>
				// </div>

				<section className="section_body_login">
					<div className="container">
						<div className="row justify-content-center">
							<div className="col-md-6">
								<div className="form_main_box">
									<div className="row">
										<div className="col-md-6">
											<div className="formbox">
												<div className="companylogo">
													<h2>Sign In to E-Admin</h2>
												</div>
												
											</div>
										</div>
										<div className="col-md-6">
											<div className="small_head">
												<div className="main-head">
													<h2><img src="/media/logos/logo.png" alt="" /></h2>
													<p>Enter your details to login to your account</p>
												</div>

												<form onSubmit={handleSubmit} className="form" id="kt_login_signin_form">

													<div className="form-group custom-form-gr">
														<label htmlFor="email">Email</label>
														<input className="form-control h-auto form-control-solid py-4 px-8" type="text" placeholder="Email" name="email" id="email" value={email} onChange={handleEmailChange} autoComplete="off" />
													</div>

													<div className="form-group custom-form-gr">
														<label htmlFor="password">Password</label>
														<input className="form-control h-auto form-control-solid py-4 px-8" type="password" placeholder="Password" name="password" id="password" value={password} onChange={handlePasswordChange} />

													</div>
													<div className="form-group">
														{/* <a className="registertextcolor" href="#">Register Yourself / Forgot Password?</a> */}
														<button id="kt_login_signin_submit" className="btn btn-outline btn-outline-primary px-9 py-4 my-3 mx-1">Sign In</button>

													</div>
												</form>
											</div>
										</div>

										<div className="lastfooter">
											{/* <p>Note: For Single Sign On access, you must have a valid BRAC Gmail id or BRAC PIN. For support Ext:3200 (from Head Office) Email: it-support@brac.net (from outside Head Office)</p> */}
										</div>

									</div>
								</div>
							</div>
						</div>
					</div>
				</section>
			}
			{loading === true &&
				<div className="d-flex flex-center" style={{ marginTop: "250px" }}>
					{/* <ReactLoading type={"bars"} color={"#ec008c"} height={'3%'} width={'5%'} /> */}
					<Spinner animation="grow" variant="primary" size="lg" />
					<span style={{ marginLeft: '10px' }}></span>
					<Spinner animation="grow" variant="primary" size="lg" />
					<span style={{ marginLeft: '10px' }}></span>
					<Spinner animation="grow" variant="primary" size="lg" />
				</div>
			}
		</>
	)
}

export default Login